export class Card {
    constructor(number: string, cvc: string) {
        this.number = number;
        this.cvc = cvc;
        if (this.number) {
            this.card = this.cardFromNumber(this.number);
        }
    }

    number: string;

    cvc: string;

    private card: any;

    private defaultFormat = /(\d{1,4})/g;

    private cards = [
        {
            type: 'amex',
            pattern: /^3[47]/,
            format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
            length: [15],
            cvcLength: [4],
            luhn: true
        }, {
            type: 'dankort',
            pattern: /^5019/,
            format: this.defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'dinersclub',
            pattern: /^(36|38|30[0-5])/,
            format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
            length: [14],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'discover',
            pattern: /^(6011|65|64[4-9]|622)/,
            format: this.defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'jcb',
            pattern: /^35/,
            format: this.defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'laser',
            pattern: /^(6706|6771|6709)/,
            format: this.defaultFormat,
            length: [16, 17, 18, 19],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'maestro',
            pattern: /^(5018|502|503|506|56|58|639|6220|67)/,
            format: this.defaultFormat,
            length: [12, 13, 14, 15, 16, 17, 18, 19],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'mastercard',
            pattern: /^(5[1-5]|677189)|^(222[1-9]|2[3-6]\d{2}|27[0-1]\d|2720)/,
            format: this.defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'unionpay',
            pattern: /^62/,
            format: this.defaultFormat,
            length: [16, 17, 18, 19],
            cvcLength: [3],
            luhn: false
        }, {
            type: 'visaelectron',
            pattern: /^4(026|17500|405|508|844|91[37])/,
            format: this.defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'elo',
            pattern: /^(4011|438935|45(1416|76|7393)|50(4175|6699|67|90[4-7])|63(6297|6368))/,
            format: this.defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'visa',
            pattern: /^4/,
            format: this.defaultFormat,
            length: [13, 16, 19],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'mir',
            pattern: /^22/,
            format: this.defaultFormat,
            length: [16],
            cvcLength: [3],
            luhn: true
        }, {
            type: 'unknown',
            pattern: /\d*/,
            format: this.defaultFormat,
            length: [12, 13, 14, 15, 16, 17, 18, 19],
            cvcLength: [3, 4],
            luhn: true
        }
    ];

    get cardType(): string | null {
        if (this.card) {
            return this.card.type;
        }

        return null;
    }

    get numberIsValid(): boolean {
        const num = (this.number + '').replace(/\s+|-/g, '');
        if (!/^\d+$/.test(num)) {
            return false;
        }
        if (!this.card) {
            return false;
        }
        return (this.card.length.indexOf(num.length) >= 0) && (this.card.luhn === false || this.luhnCheck(num));
    }

    get cvcIsValid(): boolean {
        const cvc = this.cvc;
        if (!/^\d+$/.test(cvc)) {
            return false;
        }
        if (this.card) {
            return this.card.cvcLength.indexOf(this.cvc.length) >= 0;
        } else {
            return cvc.length >= 3 && cvc.length <= 4;
        }
    }

    public formatCardNumber = function (): string | undefined {
        let groups;
        let _ref;
        let num = this.number.replace(/\D/g, '');

        if (!this.numberIsValid) {
            return num;
        }

        const upperLength = this.card.length[this.card.length.length - 1];

        num = num.slice(0, upperLength);
        if (this.card.format.global) {
            return (_ref = num.match(this.card.format)) != null ? _ref.join(' ') : void 0;
        } else {
            groups = this.card.format.exec(num);
            if (groups == null) {
                return;
            }
            groups.shift();
            groups = groups.filter(function (n) {
                return n;
            });
            return groups.join(' ');
        }
    };

    private cardFromNumber = function (num) {
        let card, j, len;
        num = (num + '').replace(/\D/g, '');
        for (j = 0, len = this.cards.length; j < len; j++) {
            card = this.cards[j];
            if (card.pattern.test(num)) {
                return card;
            }
        }
    };

    private luhnCheck = function (num) {
        let digit;
        let j;
        let len;
        let odd;
        let sum;

        odd = true;
        sum = 0;

        const digits = (num + '').split('').reverse();

        for (j = 0, len = digits.length; j < len; j++) {
            digit = digits[j];
            digit = parseInt(digit, 10);
            if ((odd = !odd)) {
                digit *= 2;
            }
            if (digit > 9) {
                digit -= 9;
            }
            sum += digit;
        }
        return sum % 10 === 0;
    };
}
